<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">服务项目</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh" @selection-change="(val) =>{ delList = val }">
           <template #isEnabled="{ row }">
              <el-switch v-model="row.isEnabled" disabled/>
          </template>
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
            >编辑</el-button>
            <ConfirmButton icon="Delete" link @confirm="click_delete(row)">删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
      </div>
    </div>
    <!-- 新增 -->
    <Dialog
      v-model="addVisible"
      :title="title"
      top="5vh"
      width="30%"
    >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      >
        <template #isEnabled="{ formData }">
           <el-switch v-model="formData.isEnabled" />
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { ref, reactive,computed,nextTick } from "vue";
import dictionary from "@/api/dict.js";
import authApi from "@/api/auth";
import {getConsultantServiceItem,postConsultantServiceItem,putConsultantServiceItem,deleteConsultantServiceItem} from "@/api/consultant.js";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
const doctorOptions=ref([])
const title = ref("新增");
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Select",
      label: "咨询师用户：",
      prop: "ConsultantId",
      options: doctorOptions,
      attrs: {
        placeholder: "请选择咨询师",
      },
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(paginationParams, formData);
        },
      },
    },
     {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
          title.value = "新增";
        },
      },
    },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "RefreshLeft",
        },
        events: {
          click(formData) {
            formData.ConsultantId=""
            paginationParams.ConsultantId = "";
          },
        },
      },
  ],
});

const emoOptions=ref([
  {label:"🎯",value:"🎯"},
  {label:"🌱",value:"🌱"},
  {label:"🤝",value:"🤝"},
  {label:"🌙",value:"🌙"},
])
const itemList = computed(() => {
  const base = [
    {
      type: "Select",
      label: "咨询师用户：",
      prop: "consultantId",
      options: doctorOptions,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "服务项目名称：",
      prop: "name",
      attrs:{
        placeholder: "请输入"
      }
    },
    {
      type: "Input",
      label: "服务项目内容：",
      prop: "content",
      attrs:{
        placeholder: "请输入"
      }
    },
    {
      type: "Input",
      label: "服务项目价格：",
      prop: "price",
      slot_name: "price",
      attrs:{
        placeholder: "请输入",
        type: "number",
      }
    },
    {
      type: "Select",
      label: "图标：",
      prop: "icon",
      options: emoOptions,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "排序：",
      prop: "sort",
      attrs:{
        placeholder: "请选择",
        type: "number",
      }
    },
    {
      type: "Slot",
      label: "是否启用：",
      prop: "isEnabled",
      slot_name: "isEnabled",
    },
  ];
  return base;
});
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    consultantId: [{ required: true, message: "咨询师不能为空", trigger: "blur" }],
    name: [{ required: true, message: "服务项目名称不能为空", trigger: "blur" }],
    content: [{ required: true, message: "服务项目内容不能为空", trigger: "blur" }],
    price: [{ required: true, message: "服务项目价格不能为空", trigger: "blur" }],
  },
  // commonAttrs: {
  //   readonly,
  // },
});
// 表格
const tableOptions = reactive({
  colList: [
    { type: "selection", width: 50 },
    { type: "index", label: "序号", width: 70 },
    { label: "服务项目名称", prop: "name" },
    { label: "服务项目内容", prop: "content" },
    { label: "服务项目价格", prop: "price" },
    { label: "图标", prop: "icon" },
    { label: "排序", prop: "sort" },
    { label: "是否启用",type: "slot", slot_name: "isEnabled"},
    { type: "slot", slot_name: "handler", label: "操作" },
  ],
  tableData: [],
});
 const doctorData=()=>{
    let obj={
       Type:2,
       SkipCount:0,
       MaxResultCount:999,
    }
    authApi.getUserList(obj).then((res) => {
      doctorOptions.value = res.data.items.map(item=>{
      return {
        label: item.userName,
        value: item.id,
        ...item
      }
    });
    // paginationParams.ConsultantId=doctorOptions.value[0].id
  })
 }
 doctorData()
// 新增服务项目
const addVisible = ref(false);

// 新增服务项目 确认按钮
const myFormRef = ref(null);
const click_confirm = () => {
   const { formRef, formData } = myFormRef.value;
    console.log(formData)
    formData.price=Number(formData.price)
    formData.sort=Number(formData.sort==null?0:formData.sort)
    formRef.validate(async(valid) => {
      if (valid) {
        let res = formData.id ? await putConsultantServiceItem(formData)
        : await postConsultantServiceItem(formData);
        ElMessage.success("操作成功");
        addVisible.value = false;
        getList();
      }
    })
};


// 编辑
const click_edit = async(row) => {
  addVisible.value = true;
  title.value = "编辑";
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
};
const delList = ref([]);
const click_delete = (row) => {
  deleteConsultantServiceItem(row.id).then(res=>{
    ElMessage.success("删除成功");
    getList();
  })
}

const paginationParams = reactive({
  ConsultantId: "",
})
const paginationRef = ref();
const total = ref(0);
const getList = (params = paginationRef.value.getList_params) => {
  // if(paginationParams.ConsultantId==""){
  //   return
  // }
  getConsultantServiceItem(params).then(res=>{
    total.value = res.data.totalCount;
    tableOptions.tableData =  res.data.items;
  });
};
</script>

<style lang="scss" scoped>
.add-user-form {
  padding: 20px 40px;
}
</style>
